// extracted by mini-css-extract-plugin
var _1 = "DataFallback_fixed__6928d";
var _2 = "DataFallback_static__78c62";
export { _1 as "fixed", _2 as "static" }
